// extracted by mini-css-extract-plugin
module.exports = {"page-content":"static-page-content_page-content__nhStT","page-content__visually-hidden-heading":"static-page-content_page-content__visually-hidden-heading__g9B4o"};